<div class="w-100 mct-flex mct-row mct-justify-end mct-items-center">
  <a (click)="showEditClick()"><span class="pi pi-cog mr-2"></span>{{ 'dashboard.reports.select-my-reports' | translate
    | titlecase }}</a>
</div>

<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ 'dashboard.reports.select-my-reports' | translate | titlecase }}
    </h4>
  </ng-template>
  @if (reportsList && reportsList.length > 0) {
  <p-accordion [value]="reportsList">
    @for (report of reportsList; track report.Title) {
    <p-accordion-panel [value]="report">
      <p-accordion-header>{{ report.Title }}</p-accordion-header>
      <p-accordion-content>
        @for (child of report.ChildItems; track child.Title) {
        @if ((child.ChildItems?.length ?? 0) == 0) {
        <div class="mct-flex mct-row mt-4 mb-4">
          <div class="mr-8">
            <p-checkbox [(ngModel)]="child.isSelected" name="isSelected" binary="true"> </p-checkbox>
          </div>
          <div>
            {{ child.Title }}
          </div>
        </div>
        }
        @if ((child.ChildItems?.length ?? 0) > 0) {
        <div class="mt-8">
          <p-accordion [value]="child.Title">
            <p-accordion-panel [value]="child">
              <p-accordion-header>{{ child.Title }}</p-accordion-header>
              <p-accordion-content>
                @for (grandchild of child.ChildItems; track grandchild.Title) {
                <div class="mct-flex mct-row" *ngIf="grandchild.ChildItems?.length ?? 0 == 0">
                  <div class="mr-8">
                    <p-checkbox [(ngModel)]="grandchild.isSelected" name="isSelected" binary="true"> </p-checkbox>
                  </div>
                  <div>
                    {{ grandchild.Title }}
                  </div>
                </div>
                }
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
        }
        }
      </p-accordion-content>
    </p-accordion-panel>
    }
  </p-accordion>
  }
  <ng-template pTemplate="footer">
    <button class="atlas-btn atlas-btn-secondary tall mr-10" [disabled]="isSaving" (click)="cancel()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button class="atlas-btn atlas-btn-primary tall" (click)="saveClicked()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
